function mainInit() {
  let $header;
  let $menu;
  let $hamburger;
  let $menuToggle;
  let $toggleLanguage;
  let $languageSwitcher;
  let scrollPosition = 0;
  let IS_OPEN_CLASS;

  const LOCK_BODY_CLASS = 'u-lock-scroll';
  const MENU_BREAKPOINT = 900; // tablet-p breakpoint in pixels

  function lockBodyScroll() {
    // Save current scroll position
    scrollPosition = window.scrollY || document.documentElement.scrollTop;
    // Apply lock class
    $('html, body').addClass(LOCK_BODY_CLASS);
    // Set negative top margin to maintain visual position
    $('body').css('margin-top', `-${scrollPosition}px`);
  }
  function unlockBodyScroll() {
    // Remove lock class and margin
    $('html, body').removeClass(LOCK_BODY_CLASS);
    $('body').css('margin-top', '');
    // Restore scroll position
    window.scrollTo(0, scrollPosition);
  }

  function closeMenu() {
    $header.removeClass('is-open');
    $menu.removeClass('is-open');
    $hamburger.removeClass('is-open');
    unlockBodyScroll();
  }

  jQuery(($) => {
    initTocActiveState();
    initTocSidebar();

    $header = $('.js-header');
    $menu = $('.js-menu');
    $hamburger = $('.js-hamburger');
    $menuToggle = $('.js-menu-toggle');
    $toggleLanguage = $('.js-toggle-language');
    $languageSwitcher = $('.js-language-switcher');
    IS_OPEN_CLASS = 'is-open';

    $menuToggle.on('click', () => {
      $header.toggleClass('is-open');
      $menu.toggleClass('is-open');
      $hamburger.toggleClass('is-open');

      if ($menu.hasClass('is-open')) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });

    // ESC key closes the main menu
    $(document).on('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (!$menu.hasClass('is-open')) return;

      e.preventDefault();
      $menuToggle.trigger('click');
      if ($menuToggle.length) {
        $menuToggle.trigger('focus');
      } else if ($hamburger && $hamburger.length) {
        $hamburger.trigger('focus');
      }
    });

    // Close menu and unlock scroll when window is resized above breakpoint
    $(window).on('resize', () => {
      if ($menu.hasClass('is-open') && window.innerWidth >= MENU_BREAKPOINT) {
        closeMenu();
      }
    });

    const accordion = new Accordion(
      '.js-accordion',
      '.js-toggle-accordion',
      '.js-accordion-content',
    );

    accordion.initClickHandling();
    if (typeof initBmiCalculator === 'function') {
      initBmiCalculator();
    }

    $toggleLanguage.on('click', function toggleLanguageSwitch(e) {
      if ($languageSwitcher) {
        $languageSwitcher.toggleClass(IS_OPEN_CLASS);
        $(this).attr('aria-expanded', $languageSwitcher.hasClass(IS_OPEN_CLASS));
      }
    });

    // Back button functionality with fallback
    $('.js-back-button').on('click', function() {
      const fallbackUrl = $(this).data('fallbackUrl');
      if (document.referrer && document.referrer !== window.location.href) {
        history.back();
        return;
      }

      if (fallbackUrl) {
        window.location.href = fallbackUrl;
      }
    });
  });
}

mainInit();
